import { crmTypes } from 'utils/helpers/crm';
import { accessLevels } from '../helpers';

const canPush = (list, user) =>
  accessLevels.push.includes(list.userAccessLevel) || user.isAccountManager;
export const hasPermissionToPushExport = user =>
  !user.isRateLimited && !user.disableExport;

export const canPushToCrm = (list, user, crmType) => {
  let crmAvailable = false;
  if (crmType === crmTypes.SALESFORCE) {
    crmAvailable = user.canPushToSalesforce && user.isSalesforceAuthenticated;
  } else if (crmType === crmTypes.HUBSPOT) {
    crmAvailable = user.canPushToHubspot && user.isHubspotAuthenticated;
  } else if (crmType === crmTypes.DYNAMICS) {
    crmAvailable = user.canPushToDynamics && user.isDynamicsAuthenticated;
  }
  return canPush(list, user) && hasPermissionToPushExport(user) && crmAvailable;
};

export const canModify = (list, user) =>
  accessLevels.modifyList.includes(list.userAccessLevel) ||
  user.isAccountManager;
export const canModifyMembers = (list, user) =>
  (accessLevels.modifyMembers.includes(list.userAccessLevel) ||
    user.isAccountManager) &&
  list.enabled;
